import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p',
  'br',
  'b',
  'strong',
  'em',
  'i',
  'u',
  's',
  'del',
  'ins',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'ul',
  'ol',
  'li',
  'blockquote',
  'hr',
  'a',
  'span',
  'div',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'colgroup',
  'col',
  'sup',
  'sub',
];

const ALLOWED_ATTR = ['href', 'target', 'rel', 'class', 'colspan', 'rowspan', 'style'];

// Force safe rel on any anchor that opens a new browsing context, closing the
// reverse-tabnabbing gap where the opened page can reach back via window.opener.
let relHookRegistered = false;
const registerRelHook = (): void => {
  if (relHookRegistered) {
    return;
  }
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.nodeName === 'A' && node.getAttribute('target')) {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
  relHookRegistered = true;
};

export const sanitizeLegalHtml = (rawHtml: string): string => {
  registerRelHook();
  return DOMPurify.sanitize(rawHtml, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // A custom ALLOWED_URI_REGEXP makes DOMPurify run *every* non-URI-safe
    // attribute through that regex; without this these plain (non-URL)
    // attributes would be stripped even though they are allow-listed above.
    ADD_URI_SAFE_ATTR: ['target', 'rel', 'colspan', 'rowspan'],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:)/i,
    FORCE_BODY: true,
  });
};
